/**
 * Perf 2026-07 — Helper cho endpoint backend `/api/img/thumb` (proxy resize thumbnails).
 *
 * VOD thumbnail của DO Spaces sinh full-HD 1280×720 (~160KB). Card list hiển thị
 * chỉ 306×172 → PageSpeed báo tiết kiệm ~3.4MB/page. Backend Pillow resize + cache
 * 1 năm → chỉ ~5-10KB/ảnh WebP.
 *
 * Chỉ thay thế URL cho các domain DO Spaces đã whitelist ở backend. Ngoài whitelist
 * → trả URL gốc (an toàn, không break iframe/poster/etc).
 */
import { BACKEND_URL } from "./api";

const ALLOWED_HOSTS = new Set([
  "pickleague-videos.sgp1.digitaloceanspaces.com",
  "sgp1.digitaloceanspaces.com",
  "pickleague-videos.sgp1.cdn.digitaloceanspaces.com",
]);

/**
 * Trả về URL đã proxy qua backend resize endpoint. Nếu URL nằm ngoài whitelist
 * hoặc không hợp lệ → trả url gốc để không thay đổi hành vi.
 *
 * @param {string} url  Nguồn ảnh (public URL).
 * @param {number} w    Width mục tiêu (default 360, dùng cho VOD card 2× retina).
 * @param {string} fmt  "webp" (default) hoặc "jpeg".
 */
export function resizeThumbUrl(url, w = 360, fmt = "webp") {
  if (!url || typeof url !== "string") return url;
  try {
    const parsed = new URL(url);
    if (!ALLOWED_HOSTS.has(parsed.hostname)) return url;
    const base = BACKEND_URL || "";
    return `${base}/api/img/thumb?u=${encodeURIComponent(url)}&w=${w}&fmt=${fmt}`;
  } catch (_e) {
    return url;
  }
}

/**
 * Đợt 2 HAR v16 (06/2026) — URL thumbnail đi THẲNG DO CDN, KHÔNG qua
 * /api/img/thumb (FastAPI không truyền byte ảnh; Pillow không tranh CPU với
 * score/tournament API). Ưu tiên bản WebP nhỏ nếu backend đã tạo sẵn.
 * /api/img/thumb chỉ còn là fallback chuyển tiếp cho nơi khác (sẽ loại bỏ dần).
 *
 * 2026-02-15 — Backfill WebP: khi có `thumbnail_small_url` (480px) hoặc
 * `thumbnail_tiny_url` (320px, mobile). Truyền `preferMobile=true` (list
 * di động) để ưu tiên bản 320px, mặc định lấy 480px cho card.
 */
export function directThumbUrl(item, { preferMobile = false } = {}) {
  if (!item) return null;
  if (preferMobile && item.thumbnail_tiny_url) return item.thumbnail_tiny_url;
  return item.thumbnail_small_url || item.thumbnail_tiny_url || item.thumbnail_url || null;
}
